import React from "react";

const ErrorMessage = ({
  message,
  title,
  style = {},
  showPrefix = true,
  prefix = "Error:",
}) => {
  if (!message) {
    return null;
  }

  const errorTitle = title || message;

  const defaultStyle = {
    color: "#d32f2f",
    fontSize: "12px",
    marginTop: "5px",
    fontStyle: "italic",
    maxWidth: "400px",
    wordBreak: "break-word",
    lineHeight: "1.4",
    padding: "4px 8px",
    backgroundColor: "#ffeaea",
    border: "1px solid #ffcccb",
    borderRadius: "4px",
    ...style,
  };

  return (
    <div style={defaultStyle} title={errorTitle}>
      {showPrefix && prefix && `${prefix} `}
      {message}
    </div>
  );
};

export default ErrorMessage;
